export const REQUEST_MAGIC_LINK = 'REQUEST_MAGIC_LINK';
